import script from "./PageHero.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHero.vue?vue&type=script&setup=true&lang=js"

import "./PageHero.vue?vue&type=style&index=0&id=661a0af9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-661a0af9"]])

export default __exports__